import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "10", cy: "16", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m16 10-4.5 4.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m15 11 1 1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileKey";
const FileKey = memo(themed(Icon));
export {
  FileKey
};
//# sourceMappingURL=file-key.js.map
